// T1-A R1 (2026-05-06):
// 月次 MEO レポート一覧 API クライアント。
// Backend: omikuji-api PR #94 で実装。
//
// auth: ADMIN (sponsor_tier ≠ 'none' の全 landmark) /
//       BUSINESS (自分が sponsor_user_id の landmark のみ)

import ApiService from './ApiService';

export default class MonthlyMeoReportsApi extends ApiService {
    fetchList() {
        return this.get('business/monthly-meo-reports');
    }
}
